(() => {
  'use strict';
  document.querySelectorAll('[data-trm-pdp-v11]').forEach((root) => {
    if (root.dataset.booted === 'true') return;
    root.dataset.booted = 'true';
    const contextNode = root.parentElement?.querySelector('[data-trm-pdp-context]') || document.querySelector('[data-trm-pdp-context]');
    const dialog = document.querySelector('[data-trm-pdp-dialog]');
    let context;
    try { context = JSON.parse(contextNode?.textContent || '{}'); } catch (_) { return; }
    const productForm = document.querySelector('product-form') || document.querySelector('form[action*="/cart/add"]');
    const buyButton = productForm?.querySelector('button[type="submit"], [name="add"]');
    const anchor = buyButton?.closest('product-form, form, .product-form, .product__buy-buttons') || productForm;
    if (anchor?.parentNode) anchor.insertAdjacentElement('afterend', root);
    root.hidden = false;

    const currentVariantId = () => document.querySelector('form[action*="/cart/add"] [name="id"]')?.value || context.selectedVariantId;
    const selectedVariant = () => context.variants.find((variant) => String(variant.id) === String(currentVariantId())) || context.variants[0];
    const persist = () => {
      context.selectedVariantId = currentVariantId();
      context.capturedAt = new Date().toISOString();
      sessionStorage.setItem('trmFinderPdpContextV11', JSON.stringify(context));
      const sku = selectedVariant()?.sku || 'SKU unavailable';
      dialog?.querySelector('[data-trm-pdp-sku]')?.replaceChildren(document.createTextNode(`Selected SKU: ${sku}`));
    };
    const open = () => {
      persist();
      if (dialog?.showModal) dialog.showModal(); else dialog?.setAttribute('open', '');
    };
    root.querySelector('[data-trm-pdp-open]')?.addEventListener('click', open);
    dialog?.querySelector('[data-trm-pdp-close]')?.addEventListener('click', () => dialog.close?.());
    dialog?.querySelector('[data-trm-pdp-guide]')?.addEventListener('click', persist);
    const openTexChat = () => {
      let chat = document.querySelector('shopify-chat');
      if (!chat) {
        chat = document.createElement('shopify-chat');
        chat.setAttribute('view', 'chat');
        document.body.appendChild(chat);
      }
      if (typeof chat.open === 'function') {
        chat.open();
        return true;
      }
      const runtime = chat.shadowRoot?.querySelector('shopify-agent-runtime');
      const launcher =
        runtime?.shadowRoot?.querySelector('button[part="activator"], button[aria-label="Need help?"]') ||
        chat.shadowRoot?.querySelector('button[part="activator"], button[aria-label="Need help?"]');
      if (launcher) {
        if (launcher.getAttribute('aria-expanded') !== 'true') launcher.click();
        return true;
      }
      return false;
    };
    const requestTexChat = (attempts = 8) => {
      if (openTexChat() || attempts <= 1) return;
      window.setTimeout(() => requestTexChat(attempts - 1), 250);
    };
    dialog?.querySelector('[data-trm-pdp-tex]')?.addEventListener('click', () => {
      persist();
      const detail = { source: 'pdp-v11', finderKey: context.finderKey, productId: context.productId, variantId: context.selectedVariantId, sku: selectedVariant()?.sku || null, guideUrl: context.guideUrl };
      window.dispatchEvent(new CustomEvent('trm:tex-open', { detail }));
      dialog.close?.();
      requestTexChat();
    });
    document.addEventListener('change', (event) => { if (event.target.matches('[name="id"], variant-selects select, variant-radios input')) queueMicrotask(persist); });
    persist();
  });
})();
